import {Observable, VirtualTimeScheduler}                                      from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';

import UiEventType from '../../../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../../../Ui/Shared/Interfaces/IUiEventsStreamPayload';

const FOCUS_CHANGE_DEBOUNCE_DURATION = 200;

const createFocusChangeStream = (
    uiEvents$: Observable<IUiEventsStreamPayload>,
    scheduler?: VirtualTimeScheduler
): Observable<boolean> =>
    uiEvents$
        .pipe(
            filter(({type}) => [UiEventType.FRAME_FOCUS, UiEventType.FRAME_BLUR].includes(type)),
            debounceTime(FOCUS_CHANGE_DEBOUNCE_DURATION, scheduler),
            map(({type}) => type === UiEventType.FRAME_FOCUS ? true : false),
            distinctUntilChanged()
        );

export {
    createFocusChangeStream as default,
    FOCUS_CHANGE_DEBOUNCE_DURATION
};